import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import App from '../pages/App.jsx'
import { auth } from './firebaseapi'
import BootScreen from '../components/common/pageLoader/bootScreen'

const loginPath = import.meta.env.BASE_URL || '/'

const ProtectedLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [authReady, setAuthReady] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const redirectToLogin = () => {
    navigate(loginPath, { replace: true })
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthReady(true)
      setIsAuthenticated(!!user)
      if (!user) {
        redirectToLogin()
      }
    })
    return unsubscribe
  }, [])

  useEffect(() => {
    if (authReady && !isAuthenticated) {
      redirectToLogin()
    }
  }, [location.pathname, authReady, isAuthenticated])

  useEffect(() => {
    // Guard against browser back-forward cache (bfcache) restoring a stale
    // authenticated page after the user has logged out.
    const handlePageShow = async (event) => {
      if (event.persisted) {
        // Page was restored from bfcache — Firebase state may be stale.
        // Force a sign-out to clear any lingering session and redirect.
        if (!auth.currentUser) {
          await signOut(auth).catch(() => {})
          redirectToLogin()
        }
      }
    }

    // Guard against the back button being pressed while unauthenticated.
    const handlePopState = () => {
      if (!auth.currentUser) {
        redirectToLogin()
      }
    }

    window.addEventListener('pageshow', handlePageShow)
    window.addEventListener('popstate', handlePopState)
    return () => {
      window.removeEventListener('pageshow', handlePageShow)
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  if (!authReady) {
    return <BootScreen />
  }
  if (!isAuthenticated) {
    return null
  }

  return <App />
}

export default ProtectedLayout
